export default __webpack_public_path__ + "static/media/render1.7ff78f9b.jpg";